/**
 * Created by danilaeremin on 11.08.15.
 */

/**
 * @class Layer for physical robot settings.
 * @extends PlayerRobotSettingsLayer
 * @constructor
 * @param {pm.AbstractRobot} robot Robot which settings need to display.
 */
var PhysicalRobotSettingsLayer = PlayerRobotSettingsLayer.extend(/** @lends PhysicalRobotSettingsLayer# */{
	ctor: function(robot)
	{
		this._super(robot);

		this._label.setString(LocalizedString("Physical") + " " + robot.id + ", " + LocalizedString("Pattern") + " " + robot.parentLevel.programData[robot.groupID].currentIndex);
	}
});
